import Dropdown from './Dropdown';
import DropdownMenu from './DropdownMenu';
import DropdownItem from './DropdownItem';

Dropdown.Item = DropdownItem;
Dropdown.Menu = DropdownMenu;

export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/dropdown/index.js
// module id = 381
// module chunks = 0